<template>
  <div id="app">
    <CateringPage :items="imageData" />
  </div>
</template>

<script>
import CateringPage from "../components/CateringPage";
export default {
  components: {
    CateringPage,
  },
  data() {
    return {
      imageData: [], // Array to store data retrieved from the backend
    };
  },
};
</script>
<style scoped></style>
